import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://api.yuvapremierleague.in'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVxZ2RweWJxbXJvanBsYWdudXlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcwMTk3NzgsImV4cCI6MjA4MjU5NTc3OH0.pJyp2iN7Y7Rj7MJylQ6os8XJUae5WmUtnvD4aqOPPxA'

if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable')
}

if (!supabaseAnonKey) {
  console.warn('Missing VITE_SUPABASE_ANON_KEY - using default (for development only)')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
